(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product-setup-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-setup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-shoplist-qcoltd"]) return;
  try {
    
  addEventListener('load',function(){
    let shoplistFilterSwiper;
    const swiperOptions = {
      slidesPerView: 3.6,
      slidesOffsetAfter: 15,
      spaceBetween: 10,
      speed: 400,
      mousewheel: {
        forceToAxis: true,
        invert: false
      },
      freeMode: true,
      freeModeMomentum: true,
      freeModeMomentumRatio: 0.5,
      freeModeMomentumBounce: false
    }
    const sidemenuElement = document.querySelector('.js-controlPostion');
    const mainElement = document.querySelector('#MainContent');

    /* Mobile幅のみ、Swiper生成 */
    function initSwiper() {
      var screenWidth = window.innerWidth;
      if(screenWidth < 768 && !shoplistFilterSwiper) { 
        shoplistFilterSwiper = new Swiper(".js-shoplist-menu-swiper", swiperOptions);
      } else if (screenWidth > 767 && shoplistFilterSwiper) {
        shoplistFilterSwiper.destroy();
        shoplistFilterSwiper = '';
      }
    }

    /* スムーススクロール */
    function smoothScrollShoplist(event) {
      const targetName = event.currentTarget.getAttribute('data-filter');
      document.querySelector('#MainContent .shopify-section.'+ targetName).scrollIntoView({behavior: 'smooth'});
    }

    function adjustSidemenuPosition(entries, observer) {
      if (!isDesktop()) return false;

      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const documentHeight = document.documentElement.scrollHeight;
          const currentWindowHeight = document.documentElement.clientHeight;
          const headerHeight = document.querySelector('sticky-header').offsetHeight;
          const sidemenuHeight = sidemenuElement.offsetHeight;
          const sidemenuTopMargin = sidemenuElement.offsetTop > headerHeight ? sidemenuElement.offsetTop : sidemenuElement.offsetTop + headerHeight;
          const footerHeight = document.querySelector('.footer').clientHeight;

          /* footerまでスクロールしたら、サイドメニューの位置をheaderの高さ分ズレるのを止める。 */
          sidemenuElement.classList.add('add-stop-sidemenu');

          /* windowの高さがsidemenuより大きいなら、sidemenuの位置を調整する */
          if (currentWindowHeight > sidemenuHeight + sidemenuTopMargin) {
            sidemenuElement.style.transform = `translate3d(0px, ${documentHeight - currentWindowHeight - footerHeight}px, 0px)`;
          }

          sidemenuElement.style.position = 'absolute';
          sidemenuElement.classList.add('add-adjust-sidemenu-bar');
          mainElement.classList.add('add-adjust-sidemenu-bar');
        } else {
          sidemenuElement.removeAttribute('style');
          sidemenuElement.classList.remove('add-adjust-sidemenu-bar');
          sidemenuElement.classList.remove('add-stop-sidemenu');
          mainElement.classList.remove('add-adjust-sidemenu-bar');
        }
      });
    }

    const isDesktop = () => window.matchMedia('(min-width: 768px)').matches

    /* 処理実行 */
    window.addEventListener('resize', initSwiper);

    /* エリアが「オンライン」のみ、URLのドメインのみを表示する */
    document.querySelectorAll('.cfs-hyperlink').forEach(function(element,index){
      if(element.href) {
        element.text = element.href.split('/')[2];
      }
    });

    /* Desktopのみ footerまでスクロールしたら、サイドメニューのposition: fixedを解除する */
    const targetElement = document.querySelector(".footer");
    const io = new IntersectionObserver(adjustSidemenuPosition);
    io.observe(targetElement);

    /* =====================
      filter項目の作成
    ===================== */
    const filterPromise = new Promise(function(resolve,reject) {
      /* =====================
        filterメニューに項目を追加
      ===================== */
      const filterClass = 'shop__list swiper-slide js-smoothscroll';
      document.querySelectorAll('.shop__detail_box').forEach(function(element,index){
        const createElement = document.createElement('li');
        createElement.setAttribute('class', filterClass);
        let areaName = element.querySelector('.shop__detail_title').textContent;
        createElement.innerHTML = '<span class="shop__areaName">' + areaName + '</span>';
        document.querySelector('.shop__box').appendChild(createElement);
      });
      resolve();
    }).then(function(){
      /* =====================
        Swiper 生成
      ===================== */
      initSwiper();
    }).then(function(){
      /* =====================
        コンテンツを表示
      ===================== */
      const allContents = document.querySelector('#MainContent');
      allContents.classList.add('is-visible');
    }).then(function(){
      /* =====================
        filterメニューに
        data-filterをつける処理
      ===================== */
      let fillterContents = document.querySelectorAll('.js-smoothscroll')
      let inheritAreaName = ''
      const ngPattern = /[ -/:-@\[-~（）]/;
      [].slice.call(fillterContents).forEach(function(elm,index){
        inheritAreaName = elm.firstChild.textContent;
        let dataFillterVerOther = '';
        // 「 () 」があるとjQueryでエラーになるので処理を追加
        if(ngPattern.test(inheritAreaName)){
          dataFillterVerOther = `エリア${index}`;
        }
        if(dataFillterVerOther == ''){
          elm.setAttribute('data-filter', inheritAreaName);
        }else{
          elm.setAttribute('data-filter', dataFillterVerOther);
        }
      });
    }).then(function(){
      /* =====================
        shoplistの各地方にclass追加
      ===================== */
      const areaSections = document.querySelectorAll('#MainContent .shopify-section:not(.shoplist-menu)');
      let areaSectionClassName = '';
      const fillterContents = document.querySelectorAll('.js-smoothscroll');
      areaSections.forEach(function(section, index) {
        section.classList.add(fillterContents[index].getAttribute('data-filter'));
      });
    }).then(function(){
      /* =====================
        smooth scroll event設定
      ===================== */
      document.querySelectorAll('.js-smoothscroll').forEach(function(element) {
        element.addEventListener('click', smoothScrollShoplist);
      });
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password-header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    const queryArray = window.location.search ? window.location.search.substring(1).split('&') : new Array();
    if (queryArray.includes('v12') || window.location.hostname.indexOf('stg') >= 0) {
      document.querySelector('password-modal').style.display = 'block';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qcoltd-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-qcoltd-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qcoltd-main-visual"] && !Shopify.designMode) return;
  try {
    
let swiper = new Swiper(".js-main-visual-swiper", {
  spaceBetween: 1,
  slidesPerView: 1,
  speed: 1000,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false
  },
  effect: "fade",
  fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  breakpoints: {
    990: {
      noSwiping: true,
      noSwipingClass:"mod-noSwipe"
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qcoltd-news-topic"] && !Shopify.designMode) return;
  try {
    
let swiper = new Swiper(".js-news-topic-swiper", {
  slidesPerView: 1.3,
  slidesOffsetAfter: 15,
  spaceBetween: 15,
  speed: 400,
  pagination: {
    el: ".swiper-pagination",
    type: 'bullets',
    clickable: true
  },
  mousewheel: {
    forceToAxis: true,
    invert: false
  },
  freeMode: true,
  freeModeMomentum: true,
  freeModeMomentumRatio: 0.5,
  freeModeMomentumBounce: false,
  breakpoints: {
    768: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      slidesOffsetAfter: 0,
      spaceBetween: 20
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qcoltd-pickup"] && !Shopify.designMode) return;
  try {
    

/* Tablet MobileはSwiper */
const isMobile = window.matchMedia('(max-width: 989px)');
let pickupSwiper;

if (isMobile.matches) createPickupSwiper();

window.addEventListener('resize',initPickupSwiper);

function createPickupSwiper() {
  pickupSwiper = new Swiper('.js-pickup-swiper', {
    slidesPerView: 2.25,
    slidesOffsetAfter: 15,
    spaceBetween: 14,
    speed: 400,
    pagination: {
      el: ".swiper-pagination",
      type: 'bullets',
      clickable: true
    },
    mousewheel: {
      forceToAxis: true,
      invert: false
    },
    freeMode: true,
    freeModeMomentum: true,
    freeModeMomentumRatio: 0.5,
    freeModeMomentumBounce: false
  });
}

function initPickupSwiper() {
  if (pickupSwiper && !isMobile.matches) {
    pickupSwiper.destroy(true, true);
    pickupSwiper = null;
  } else if (!pickupSwiper && isMobile.matches) {
    createPickupSwiper();
  }
}


  } catch(e) { console.error(e); }
})();
})();
